module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-7.svg";